<div class="chart-row row">
  <div class="col-md-auto d-flex align-items-center justify-content-center">
    <div class="chart-container">
      <app-donut-chart class="chart" [data]="data" />
    </div>
  </div>
  <div class="col-md">
    <div id="legend-container">
      <app-donut-chart-legend [showTotalRow]="showTotalRow" [data]="data" />
    </div>
  </div>
</div>
